import React from 'react';
import PropTypes from 'prop-types';
import CoachingAgendaCard from 'components/dashboard/CoachingAgendaCard';
import Button from '@material-ui/core/Button';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import {navigateToCallsTab} from 'utils/navigateToCallsTab';
import {List} from 'immutable';
import AgendaColumnHeader from 'components/dashboard/AgendaColumnHeader';
import {CoachingReviewTypeDisplayAndChooser} from 'components/dashboard/common/CoachingReviewTypeDisplayAndChooser';
import AgendaMeetingLink from './AgendaMeetingLink';

export default class CoachPendingAgendaColumn extends React.PureComponent {
  render() {
    const {reviews, reviewTypes, plans} = this.props;
    return (
      <div className="coach-column agenda-column">
        <AgendaColumnHeader
          popoverMessage="These coaching meetings require action on your part before review preparation is complete. Hover over each meeting to see what action you need to take."
          title="Pending Your Action"
        />
        {reviews.isEmpty() ? (
          <div className="coach-empty empty-agenda">
            <div className="check-icon" />
            <div className="empty-descr">Great job, you're caught up!</div>
          </div>
        ) : (
          reviews.map(r => (
            <CoachingAgendaCard
              key={r.id}
              rep={r.coachingPlan.recipient.info}
              pendingType="COACH"
              onEditPlan={this.props.onEditPlan}
              refreshCoachingData={this.props.refreshCoachingData}
              review={r}
              plans={plans}>
              <CoachingReviewTypeDisplayAndChooser
                review={r}
                reviewTypes={reviewTypes}
                onSetReviewType={this.props.onSetReviewType}
              />
              <div className="coach-cta">Please {r.todo.toPhrase()}.</div>
              {r.todo.pickReviewType || (
                <Button
                  variant="outlined"
                  className="ev-button"
                  onClick={() => {
                    CoachingPlaylistActions.setAddCallsMode({
                      planId: r.planId,
                      recipient: r.coachingPlan.recipient.info,
                    });
                    navigateToCallsTab();
                  }}>
                  Open Todo List
                </Button>
              )}
              <AgendaMeetingLink review={r} />
            </CoachingAgendaCard>
          ))
        )}
      </div>
    );
  }
}

CoachPendingAgendaColumn.propTypes = {
  reviews: PropTypes.instanceOf(List), // List<CoachingReview>
};
